import React from 'react';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {Card, Col, Container, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
// @ts-ignore
import isExternal from 'is-url-external';
import "./c72_boxes_with_links.scss";


interface C72BoxWithLinkData {
    label: string;
    url: string;
}

interface C72BoxesWithLinksData {
    links: C72BoxWithLinkData[];
}

class C72BoxesWithLinks extends TemplateComponent<C72BoxesWithLinksData> {

    componentRender(data: C72BoxesWithLinksData): React.ReactElement {

        return (
            <Container fluid={true} className={"c72-boxes-with-links auto-margins " + (data.links.length === 2 ? "extra-small" : "")}>
                <Row className={"boxes-" + data.links.length}>
                    {data.links.map(link => {

                        let cardContent = (
                            <Card.Body>
                                <Card.Title>{link.label}</Card.Title>
                            </Card.Body>
                        );

                        let colSizes = {};
                        if (data.links.length === 5 || data.links.length === 6) {
                            colSizes = {
                                xs: true,
                                xl: 4
                            };
                        }

                        return (
                            <Col key={"card-" + link.url} {...colSizes} >
                                <Card>
                                    {(isExternal(link.url)
                                        || link.url.startsWith("https://")
                                        || link.url.startsWith("http://")) ?
                                        <a href={link.url}>
                                            {cardContent}
                                        </a>
                                        :
                                        <Link to={link.url}>
                                            {cardContent}
                                        </Link>
                                    }
                                </Card>
                            </Col>
                        );
                    })}
                </Row>
            </Container>
        );
    }
}

export default C72BoxesWithLinks;